// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sawk: PokeData = {
  "id": 539,
  "name": "sawk",
  "height": 14,
  "weight": 510,
  "base_experience": 163,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "karate-chop",
    "double-kick",
    "leer",
    "counter",
    "focus-energy",
    "bide",
    "reversal",
    "endure",
    "rock-smash",
    "brick-break",
    "bulk-up",
    "close-combat",
    "low-sweep",
    "quick-guard",
    "retaliate"
  ],
  "moves": [
    "karate-chop",
    "double-kick",
    "leer",
    "rock-smash",
    "bulk-up",
    "close-combat",
    "jump-kick",
    "superpower",
    "drain-punch",
    "rolling-kick",
    "vacuum-wave",
    "coaching",
    "meteor-assault"
  ],
  "evolution_chain": {
    "id": 275,
    "item": null,
    "species": [
      {
        "name": "sawk",
        "order": 540,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 105,
    "speed": 119,
    "ability_power": 175
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
